module.exports = __webpack_public_path__ + "img/cafedelmor.9e5a0c0a.png";